// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1effS","addWidgetButton":"Header_addWidgetButton__32yak","dashboardTabs":"Header_dashboardTabs__2Ywi5","active":"Header_active__YF5G3"};